/* eslint camelcase: 0 */
import { Query } from '@/infrastructure/network/Upstream/schema'
import { EmptyQueryPropsFactory, IQueryProps } from '@/entities/Query'
import { IQueryProps as IUpstreamQueryProps, EmptyQueryPropsFactory as EmptyUpstreamQueryPropsFactory } from '@/entities/Upstream/Query'

export const toQueryProps = (props?: Query): IQueryProps => {
  if (!props) {
    return EmptyQueryPropsFactory()
  }
  const { total, page, take, count, sort, desc } = props
  return EmptyQueryPropsFactory({
    total,
    page: page - 1,
    take,
    count,
    sort,
    desc
  })
}

export const toUpstreamQueryProps = (props?: IQueryProps): IUpstreamQueryProps => {
  if (!props) {
    return EmptyUpstreamQueryPropsFactory()
  }
  const { total, page, take, count, sort, desc, word, query } = props
  return EmptyUpstreamQueryPropsFactory({
    skip: page * take,
    take,
    count,
    sort,
    desc,
    total,
    word,
    query: query ? JSON.stringify(query) : null
  })
}
